module.exports = __webpack_public_path__ + "img/2024-08-29b_3.36f9edf5.jpg";